/**
 * api/settings.js — App settings
 *
 * GET /api/settings           → { data: { companyName, linkedinPage, ... } }
 * GET /api/settings/:key      → single value
 * PUT /api/settings/:key      → update a single key (admin only)
 */

import client from './client';

export const settingsApi = {

  async getAll() {
    const { data } = await client.get('/settings');
    return data.data ?? data;
  },

  async get(key) {
    const { data } = await client.get(`/settings/${key}`);
    return data.data ?? data;
  },

  /** Update a single setting key (admin only). */
  async set(key, value) {
    const { data } = await client.put(`/settings/${key}`, { value });
    return data.data ?? data;
  },

  /**
   * Update multiple settings in one call.
   * Sends one PUT per key — a bulk endpoint can be added to the backend later.
   */
  async setMany(obj) {
    const results = {};
    for (const [key, value] of Object.entries(obj)) {
      results[key] = await this.set(key, value);
    }
    return results;
  },

};
